import { createVanIconComponent } from "./van"

const Plus = createVanIconComponent("plus")
export default Plus
